// extracted by mini-css-extract-plugin
export default {"centered":"CompletedWorklistsPage-styles-module--centered--uBnBd"};